var findOption = function (options, partialOption) {
    if ((partialOption.id === null || partialOption.id === undefined) && (partialOption.value === null || partialOption.value === undefined))
        return null;
    var option = options.find(function (option) { return option.id === partialOption.id || option.value === partialOption.value; });
    return option;
};
export default findOption;
//# sourceMappingURL=findOption.js.map